var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import selectn from "selectn";
import { Link } from "react-router-dom";
import formatPublishedDate from "../../../utils/formatPublishedDate";

import { FRONTEND_ROOT } from "../../../config/constants";
import styles from "./MiniStoryCard.css";

var MiniStoryCard = function (_Component) {
  _inherits(MiniStoryCard, _Component);

  function MiniStoryCard() {
    _classCallCheck(this, MiniStoryCard);

    return _possibleConstructorReturn(this, (MiniStoryCard.__proto__ || Object.getPrototypeOf(MiniStoryCard)).apply(this, arguments));
  }

  _createClass(MiniStoryCard, [{
    key: "render",
    value: function render() {
      var latest = this.props.latest;
      if (!latest) return null;
      var section = latest.content_type === "newsletter" ? "Newsletters" : selectn("primary_section.name", latest);
      var publishedDateFormatted = formatPublishedDate(latest);
      var divider = (latest.is_featured || publishedDateFormatted) && section && " / ";
      return React.createElement(
        "div",
        { key: latest.id, className: styles.root },
        React.createElement(
          Link,
          { className: styles.headline, to: latest.permalink.replace(FRONTEND_ROOT, "") + "?source=sidebar" },
          React.createElement(
            "h3",
            { className: styles.headline },
            latest.headline
          )
        ),
        React.createElement(
          "div",
          { className: styles.subtext },
          latest.is_featured ? React.createElement(
            "span",
            { className: styles.featured },
            "Featured"
          ) : publishedDateFormatted,
          divider,
          section
        )
      );
    }
  }]);

  return MiniStoryCard;
}(Component);

export default MiniStoryCard;


// WEBPACK FOOTER //
// ./src/components/Library/MiniStoryCard/MiniStoryCard.js